import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';
import Textfield from '@atlaskit/textfield';
import { FilterSelect } from './FilterSelect';
import { SortFilterOptions, StatusFilterOptions, TypeFilterOptions } from './filterOptions';
import useForumCategories from 'hooks/ai-forums/useForumCategories';

import { useFeedWallParams } from 'hooks/useFeedWallParams';

export const FeedFilters = () => {
  const { normalizedFilterOptions } = useForumCategories();
  const { categoryId, type, sort, status, tag, setCategory, setType, setSort, setStatus, setTag } = useFeedWallParams();

  const handleCategoryChange = (option: any) => {
    if (option && option.value) {
      setCategory(option.value);
    } else {
      setCategory(undefined);
    }
  };

  const getSelectedOption = (options: any[], value: string | null) => {
    if (!value) return null;
    return options.find((option) => option.value === value) || null;
  };

  const selectedCategory = getSelectedOption(
    normalizedFilterOptions.flatMap((group) => ('options' in group ? group.options : [group])),
    categoryId,
  );

  return (
    <>
      <FilterSelect
        id="collection-select"
        label="Collection"
        options={normalizedFilterOptions}
        placeholder="Collection"
        menuMinWidth={220}
        onChange={handleCategoryChange}
        value={selectedCategory}
      />
      <FilterSelect
        id="type-select"
        label="Type"
        options={TypeFilterOptions}
        placeholder="Type"
        value={getSelectedOption(TypeFilterOptions, type)}
        onChange={(option) => setType(option?.value)}
      />
      <FilterSelect
        id="sort-select"
        label="Sort"
        options={SortFilterOptions}
        placeholder="Sort"
        value={getSelectedOption(SortFilterOptions, sort)}
        onChange={(option) => setSort(option?.value)}
      />
      <FilterSelect
        id="status-select"
        label="Status"
        options={StatusFilterOptions}
        placeholder="Status"
        value={getSelectedOption(StatusFilterOptions, status)}
        onChange={(option) => setStatus(option?.value)}
      />
      <div css={tagInputContainerStyles}>
        <Textfield
          placeholder="Contains tag"
          css={tagInputStyles}
          value={tag}
          onChange={(e) => setTag((e.target as HTMLInputElement).value)}
        />
      </div>
    </>
  );
};

const tagInputContainerStyles = css({
  flex: 1,
  [MOBILE.MEDIA_QUERY]: {
    justifyContent: 'flex-end',
    marginTop: token('space.050', '4px'),
  },
});

const tagInputStyles = css({
  background: token('elevation.surface', '#F4F5F7'),
  minWidth: 240,
  maxWidth: '100%',
});
